var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dropdown",
    transform: "translate(0 27) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2609",
    "data-name": "Path 2609",
    d: "M27,27H0V0H27Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1961",
    "data-name": "Group 1961",
    transform: "translate(2.5 2.444)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_217",
    "data-name": "Ellipse 217",
    cx: 11,
    cy: 11.056,
    rx: 11,
    ry: 11.056,
    fill: "#52555e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2618",
    "data-name": "Path 2618",
    d: "M0,0,6.7,6.735,0,13.47",
    transform: "translate(13.126 18.07) rotate(180)",
    fill: "none",
    stroke: "#f2f7ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.1329cc085bd511e68cc60ae4191858fd.svg";
export { ForwardRef as ReactComponent };